import { useState } from 'react';
import { createAlert } from '../api/client';
import './AlertModal.css';

function AlertModal({ isOpen, onClose, crypto }) {
    const [alertPrice, setAlertPrice] = useState(crypto?.price?.toFixed(2) || '');
    const [alertCondition, setAlertCondition] = useState('above');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !crypto) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!alertPrice || isNaN(parseFloat(alertPrice))) {
            alert('Ве молиме внесете валидна цена');
            return;
        }

        setIsSubmitting(true);
        try {
            await createAlert({
                crypto: crypto.name,
                symbol: crypto.symbol,
                condition: alertCondition,
                price: parseFloat(alertPrice),
            });
            onClose();
        } catch (error) {
            console.error('Failed to create alert:', error);
            alert('Грешка при креирање на предупредување');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content alert-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Креирај предупредување за {crypto.symbol}</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit} className="alert-form">
                    <div className="form-group">
                        <label>Криптовалута</label>
                        <input
                            type="text"
                            value={`${crypto.name} (${crypto.symbol})`}
                            disabled
                            className="disabled-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Тековна цена</label>
                        <input
                            type="text"
                            value={`$${crypto.price.toFixed(2)}`}
                            disabled
                            className="disabled-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="condition">Услов</label>
                        <select
                            id="condition"
                            value={alertCondition}
                            onChange={(e) => setAlertCondition(e.target.value)}
                            className="form-select"
                        >
                            <option value="above">Над</option>
                            <option value="below">Под</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="price">Целна цена ($)</label>
                        <input
                            id="price"
                            type="number"
                            step="0.01"
                            value={alertPrice}
                            onChange={(e) => setAlertPrice(e.target.value)}
                            placeholder="Внесете цена"
                            className="form-input"
                            required
                        />
                    </div>

                    <div className="modal-actions">
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-secondary"
                            disabled={isSubmitting}
                        >
                            Откажи
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Креирање...' : 'Креирај предупредување'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AlertModal;
